import { put, takeLatest } from 'redux-saga/effects';

import { setFilter } from './duck';

// @effect Action
export const filter$ = 'queued/filter$';

// @effect Creators
export const filterOrders = (filters) => ({
  type: filter$,
  payload: filters,
});

// Workers
function* filter({ payload }) {
  yield put(setFilter(payload));
}

// Watchers
export function* watchQueued() {
  yield takeLatest(filter$, filter);
}
